import { Fab } from "@rmwc/fab";
import {
  ListDivider,
  ListItem,
  ListItemMeta,
  ListItemPrimaryText,
  ListItemSecondaryText,
  ListItemText
} from "@rmwc/list";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { DistributionCountDown } from "./DistributionCountDown";

import "@rmwc/fab/styles";
import "@rmwc/list/styles";

//CSS
import { UNITE_FAMILLE } from "Achat/Constants";
import { useGetServiceTypeLibelle } from "Achat/Components/Utils/achatHook";
import "./DistributionListItem.css";
import { DistributionQuantite } from "./DistributionQuantite";
// #region FONCTION COMPOSANT
/**
 * Composant permettant d'afficher un achat
 * @category Distribution
 * @param {DistributionListItem.propTypes} props Les propriétés du composant
 */
function DistributionListItem(props) {
  //#region INITIALISATION
  // Récupération des props
  const {
    detailAchat,
    handleRachat
  } = props;

  // Traduction i18n (nom de service selon la langue courante)
  const { t } = useTranslation();
  const translatedServiceName = useGetServiceTypeLibelle(detailAchat.idServiceType);
  const displayServiceName = translatedServiceName || detailAchat.serviceNom;
  // #endregion

  //#region INTERFACE
  return (
    <>
      <ListItem
        key={detailAchat.idDetailAchat}
        ripple={false}
        style={{ height: "90px" }}
      >
        <ListItemText>
          <ListItemText>
            <ListItemPrimaryText>{detailAchat.terminalNom}</ListItemPrimaryText>
            <ListItemSecondaryText>{displayServiceName}</ListItemSecondaryText>
            {detailAchat.codeAcces ?
              <ListItemSecondaryText>{t("distribution.accesCode")} &nbsp;
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  {detailAchat.codeAcces}
                </span>
              </ListItemSecondaryText>
              : null
            }
          </ListItemText>
        </ListItemText>
        <ListItemMeta>
          {detailAchat.famille === UNITE_FAMILLE.VOLUME
            ?
            <DistributionQuantite detailAchat={detailAchat} />
            :
            <DistributionCountDown
              detailAchat={detailAchat}
            />
          }

        </ListItemMeta>
      </ListItem>
      {detailAchat.idServiceType !== 10
        ?
        <div className="DistributionListItem-Button">
          <Fab
            icon="shopping_cart"
            label={t("distribution.rachat")}
            onClick={() => handleRachat(detailAchat)}
          />
        </div>
        :
        null
      }
      <ListDivider />
    </>
  )
  // #endregion
};
// #endregion

// #region PROPRIETES
/**
 * Type des propriétés de {@link DistributionListItem}
      * @typedef {Object} DistributionListItem.propTypes
      * @property {object} detailAchat L'item de la catégorie
      */
DistributionListItem.propTypes = {
  detailAchat: PropTypes.object.isRequired
};
// #endregion

export { DistributionListItem };

